module.exports = __webpack_public_path__ + "static/media/onboarding.00297807.svg";